


















































import Vue from "vue"
import CardListItem from "~/components/guideline/cardList/CardListItem.vue"
import FavoriteIcon from "~/components/guideline/icon/FavoriteIcon.vue"

export default Vue.extend({
  components: {
    CardListItem,
    FavoriteIcon,
  },
  props: {
    linkPath: {
      type: String,
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    mainJob: {
      type: String,
      default: null,
    },
    isFreelance: {
      type: Boolean,
      required: true,
    },
    profileImageUrl: {
      type: String,
      default: null,
    },
    corporationLogoImageUrl: {
      type: String,
      default: null,
    },
    corporationName: {
      type: String,
      default: null,
    },
    // 企業が在籍中の企業かどうかを示すフラグ
    isCurrentCorporation: {
      type: Boolean,
      default: null,
    },
    // お気に入りアイコンを表示するかどうかを示すフラグ
    enableFavorite: {
      type: Boolean,
      required: true,
    },
    // お気に入りされているかどうかを示すフラグ
    isFavorited: {
      type: Boolean,
      default: null,
    },
  },
  methods: {
    handleClickFavoriteIcon() {
      this.$emit("click-favorite-icon")
    },
  },
})
